import { OBSERVATORY } from "../enums/Type";

export const isPrivateMode =
  process.env.VUE_APP_DOMAIN === "kashiwa-syokuin.riskma.jp";

export const isPublicMode = !isPrivateMode;

export const getPumpStatusText = status => {
  switch (status) {
    case "driving":
      return "運転";
    case "stop":
      return "停止";
    case "failure":
      return "故障";
    default:
      return "不明";
  }
};

export const convertManholeTimeSeries = observatory => {
  // const types = [OBSERVATORY.MANHOLE.code, OBSERVATORY.MANHOLE_WATERWAY.code];
  const types = [OBSERVATORY.MANHOLE_WATERWAY.code];
  if (!types.includes(observatory.type)) {
    return;
  }
  if (!observatory.timeSeries || observatory.timeSeries.length === 0) {
    return;
  }
  if (observatory.landform === undefined || observatory.landform.length === 0) {
    return;
  }
  const arrY = observatory.landform.map(lf => lf[1]).filter(y => y > 0);
  const maxY = Math.max(...arrY);
  observatory.timeSeries.forEach(ts => {
    if (ts.level !== undefined && ts.level > maxY) {
      ts.level = maxY;
    }
  });
};
